<ng-container *ngIf="showComposerSection">
    <div class="chat-composer-shell">
        <ng-container *ngIf="canReplyToConversation; else blockedComposerState">
            <div class="reply-card" [formGroup]="replyForm">
                <div class="composer-topline mb-3">
                    <div>
                        <div class="font-semibold text-lg">Responder</div>
                        <small class="text-600">{{ replyHelperText }}</small>
                    </div>
                    <div *ngIf="requiresTemplateReply" class="composer-chip">
                        Mensaje aprobado
                    </div>
                </div>

                <div *ngIf="requiresTemplateReply" class="template-flow mb-3">
                    <div class="template-preview surface-50 border-round p-3 mb-3">
                        <div class="font-medium mb-1">Conversación vencida</div>
                        <div class="text-700">Esta conversación venció por política de WhatsApp. Podés enviar un mensaje para retomarla.</div>
                    </div>

                    <button
                        pButton
                        type="button"
                        label="Enviar mensaje para retomar"
                        icon="pi pi-whatsapp"
                        class="p-button-success"
                        [disabled]="processingReactivationTemplate"
                        (click)="sendReactivationTemplate()">
                    </button>
                </div>

                <div *ngIf="!requiresTemplateReply" class="composer-row">
                    <textarea
                        formControlName="body_text"
                        rows="2"
                        class="p-inputtext p-component w-full composer-textarea"
                        placeholder="Escribí un mensaje para el cliente">
                    </textarea>

                    <button pButton type="button" [label]="replyButtonLabel" icon="pi pi-send" class="p-button-success primary-send-button" [disabled]="processingReply" (click)="sendReply()"></button>
                </div>
            </div>
        </ng-container>

        <ng-template #blockedComposerState>
            <div class="reply-card reply-card-blocked">
                <div class="blocked-composer-state">
                    <div>
                        <div class="font-semibold text-lg">{{ composerBlockedTitle }}</div>
                        <small class="text-600">{{ composerBlockedDescription }}</small>
                    </div>

                    <div *ngIf="showTakeConversationAction" class="blocked-composer-actions">
                        <button pButton type="button" label="Tomar conversación" icon="pi pi-user-plus" class="p-button-success" [disabled]="processingTake" (click)="takeConversation()"></button>
                        <small *ngIf="canManageAssignment" class="text-500">Si preferís derivarla, usá “Asignar usuario” en la columna de gestión.</small>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</ng-container>

<ng-container *ngIf="showManagementSection">
    <div class="card action-card h-full">
        <div class="action-card-header">
            <div class="font-semibold text-xl">Gestión de la conversación</div>
            <small class="text-600">Lo operativo queda acá, separado del chat.</small>
        </div>
        <ng-container *ngIf="canEditInbox; else inboxReadOnlyState">
        <div class="secondary-stack">
            <div class="secondary-card" [formGroup]="assignForm">
                <div class="font-medium mb-1">Asignar usuario</div>
                <ng-container *ngIf="canManageAssignment; else assignmentRestrictedState">
                    <p-dropdown
                        [options]="assignableUsers"
                        optionLabel="display_label"
                        optionValue="id"
                        [placeholder]="loadingUsers ? 'Cargando usuarios...' : 'Seleccioná un usuario'"
                        formControlName="assigned_user_id"
                        [showClear]="true"
                        [disabled]="loadingUsers || processingAssign"
                        class="w-full mb-2 full-width-dropdown">
                    </p-dropdown>
                    <div *ngIf="loadingUsers" class="dropdown-loading-hint mb-2">
                        <p-progressSpinner styleClass="dropdown-loading-spinner" strokeWidth="6" [style]="{ width: '1rem', height: '1rem' }"></p-progressSpinner>
                        <small class="text-500">Cargando usuarios asignables...</small>
                    </div>
                    <button pButton type="button" label="Guardar asignación" icon="pi pi-share-alt" class="w-full p-button-outlined" [disabled]="loadingUsers || processingAssign" (click)="assignConversation()"></button>
                </ng-container>
                <ng-template #assignmentRestrictedState>
                    <small class="text-500 block">Tu grupo de acceso no tiene permiso para modificar la asignación de conversaciones.</small>
                </ng-template>
            </div>

            <div class="secondary-card" [formGroup]="statusForm">
                <div class="font-medium mb-1">Estado</div>
                <p-dropdown [options]="statusOptions" optionLabel="nombre" optionValue="valor" formControlName="status_code" class="w-full mb-2 full-width-dropdown"></p-dropdown>
                <button pButton type="button" label="Guardar estado" icon="pi pi-check" class="w-full p-button-outlined" [disabled]="processingStatus" (click)="changeStatus()"></button>
            </div>

            <div class="secondary-card derivation-card surface-border border-1 border-round p-3">
                <div class="flex justify-content-between align-items-center gap-2 mb-3">
                    <div>
                        <div class="font-medium mb-1">Derivación externa</div>
                        <small class="text-500">Auditá la salida y abrí WhatsApp Web con el resumen listo para enviar.</small>
                    </div>
                    <button pButton type="button" class="p-button-text p-button-sm handoff-toggle-button" label="Editar datos" icon="pi pi-pencil" (click)="openExternalHandoffDialog()"></button>
                </div>

                <div *ngIf="conversation?.external_handoff_summary" class="handoff-summary mb-3">
                    <div class="font-medium">{{ conversation?.external_handoff_summary }}</div>
                    <div class="handoff-destination mt-2">
                        <i class="pi pi-arrow-right"></i>
                        <span>Derivado a {{ conversation?.external_handoff_target_phone || 'Sin destino' }}<span *ngIf="conversation?.external_handoff_responsible_name"> · {{ conversation?.external_handoff_responsible_name }}</span></span>
                    </div>
                </div>

                <small class="text-500 block">Editá destino, responsable y resumen antes de abrir WhatsApp Web.</small>
            </div>

            <!-- <div *ngIf="canReopenConversation" class="secondary-card">
                <div class="font-medium mb-1">Reapertura operativa</div>
                <small class="text-500 block mb-3">Usala cuando el caso vuelve al inbox después de cierre, resolución o derivación.</small>
                <button pButton type="button" label="Reabrir conversación" icon="pi pi-replay" class="w-full p-button-secondary" [disabled]="processingReopen" (click)="reopenConversation()"></button>
            </div> -->
        </div>
        </ng-container>
        <ng-template #inboxReadOnlyState>
            <div class="secondary-card">
                <div class="font-medium mb-1">Acceso de solo lectura</div>
                <small class="text-500 block">Tu grupo puede ver la conversación, pero no tiene permiso de edición sobre el registro Inbox WhatsApp.</small>
            </div>
        </ng-template>
    </div>
</ng-container>

<p-dialog
    [(visible)]="externalHandoffDialogVisible"
    position="center"
    modal="true"
    header="Derivación externa"
    [breakpoints]="{'960px': '75vw', '400px': '95vw'}"
    [style]="{width: '42vw', maxWidth: '42rem'}"
    [closeOnEscape]="!processingExternalHandoff"
    [closable]="!processingExternalHandoff"
    (onHide)="closeExternalHandoffDialog()">
    <div [formGroup]="externalHandoffForm" class="handoff-dialog-content">
        <div class="handoff-field-group">
            <label class="field-label" for="external-handoff-target-phone">Número destino</label>
            <input pInputText id="external-handoff-target-phone" type="text" class="w-full" formControlName="target_phone" placeholder="Ej. 0981123456" (blur)="normalizeExternalHandoffTargetPhone()">
            <small class="text-500">Se normaliza automáticamente a +595 para WhatsApp Web.</small>
        </div>

        <div class="handoff-field-group">
            <label class="field-label" for="external-handoff-responsible">Responsable / referencia</label>
            <input pInputText id="external-handoff-responsible" type="text" class="w-full" formControlName="responsible_name" placeholder="Nombre de quien sigue el caso">
        </div>

        <div class="flex justify-content-between align-items-center gap-2 flex-wrap">
            <small class="text-500">El resumen se puede editar antes de abrir WhatsApp Web.</small>
            <button pButton type="button" label="Regenerar resumen" icon="pi pi-refresh" class="p-button-text p-button-sm" [disabled]="processingExternalHandoff" (click)="regenerateExternalHandoffSummary()"></button>
        </div>

        <div class="handoff-field-group">
            <label class="field-label" for="external-handoff-summary">Resumen</label>
            <textarea id="external-handoff-summary" formControlName="summary" rows="8" class="p-inputtext p-component w-full composer-textarea" placeholder="Resumen operativo para dejar auditado y enviar"></textarea>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="handoff-dialog-footer">
            <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="processingExternalHandoff" (click)="closeExternalHandoffDialog()"></button>
            <button pButton type="button" label="Abrir WhatsApp Web" icon="pi pi-whatsapp" class="p-button-warning" [disabled]="processingExternalHandoff" (click)="saveExternalHandoff()"></button>
        </div>
    </ng-template>
</p-dialog>
